import { useCallback, useState } from 'react';
import { ApiError, OpenAPI } from '../openapi';
import Cookies from 'js-cookie';
import { useErrorHandlingSlice } from 'app/error/slice';
import { useDispatch } from 'react-redux';
import { NotificationType } from 'app/error/slice/types';
import { getAccessToken } from 'utils/tokenManager';
// import { AuthenticationApIsService, Login, LoginUser } from 'services/openapi';

export function useApi() {
  const [error, setError] = useState<ApiError | unknown>(undefined);
  const [isLoading, setIsloading] = useState<boolean>(true);
  const dispatch = useDispatch();
  const { actions } = useErrorHandlingSlice();
  OpenAPI.BASE =
    process.env.REACT_APP_API_BASE_URL ?? 'https://finance-dev-api.mav-s.com';

  //show tost for CORS error
  const showToast = useCallback(
    (message: string, type: NotificationType = 'error') => {
      dispatch(
        actions.dispatchToast({
          errorTxt: message,
          show: true,
          errorType: type,
        }),
      );
      dispatch(actions.setToastDelay(5000));
    },
    [dispatch, actions],
  );

  // Check for specific CORS error patterns
  const isCorsError = (error: any): boolean => {
    return (
      (error instanceof TypeError && error.message.includes('CORS')) ||
      (error.message && error.message.includes('CORS policy')) ||
      (error.message &&
        error.message.includes('Access-Control-Allow-Origin')) ||
      (error.message && error.message.includes('preflight')) ||
      (error.name === 'TypeError' &&
        error.message.includes('Failed to fetch')) ||
      (error.status === 0 && error.type === 'cors')
    );
  };

  //function Invoke CORS Error
  const handleCorsError = useCallback(() => {
    let corsErrorMessage =
      'Something went wrong, Please try again in  few minutes.';
    showToast(corsErrorMessage);
    setError(corsErrorMessage);
    return corsErrorMessage;
  }, [showToast]);

  const handleRequest = useCallback(async function <T>(
    request: Promise<T>,
    genericToastRequired = true,
  ) {
    setIsloading(true);
    try {
      const token = await getAccessToken();
      OpenAPI.HEADERS = {
        Authorization: token ? `Bearer ${token}` : '',
        'Accept-Language': 'en-US',
      };
      const response = await request;
      setError(undefined);
      return response;
    } catch (err) {
      // Handle CORS errors && show Toast
      if (isCorsError(err)) {
        handleCorsError();
      }

      var apiError = err as ApiError;
      var errorMessage = 'something went wrong';
      if (apiError) {
        if (typeof apiError.body === 'string') {
          errorMessage = apiError.body;
        } else {
          errorMessage = apiError.body.title;
        }
      }

      // setError(err);
      if (genericToastRequired) {
        dispatch(
          actions.dispatchToast({
            errorTxt: apiError.statusText,
            show: true,
            errorType: 'error',
          }),
        );
      } else {
        console.log('generic Toast Not Required');
      }
      throw err;
    } finally {
      setIsloading(true);
    }
  },
  []);

  function dismissError() {
    setError(undefined);
  }

  return { dismissError, error, isLoading, handleRequest };
}

export default useApi;
